module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Text/Menu-c98ade7195e49762e465c36532c83eccdf429e28e05404034c13db300af3bd2b.svg";